module.exports = __webpack_public_path__ + "img/发怒.646da72c.png";